import React from 'react';
import PropTypes from 'prop-types';
import useDataSource from '@afosto/app-components-react/DataSource/useDataSource';
import useIntl from '@afosto/utils-react/intl/useIntl';
import { FormattedMessage } from 'react-intl';
import IconButton from '@material-ui/core/IconButton';
import Grid from '@material-ui/core/Grid';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import ItemCard from '../ItemCard';
import DataList from '@afosto/app-components-react/DataList';
import Dialog from '@afosto/app-components-react/Dialog';
import Icon from '@afosto/app-components-react/Icon';
import styled from 'styled-components';
import translations from './translations';

const CloseButton = styled(IconButton)`
  && {
    position: absolute;
    right: ${props => props.theme.spacing(1)}px;
    top: ${props => props.theme.spacing(1)}px;
    color: ${props => props.theme.palette.grey[500]};
  }
`;

const DataListGridContainer = props => <Grid container spacing={1} {...props} />;

const ItemResultsDialog = ({ isOpen, onClose, onSelect, results }) => {
  const intl = useIntl();
  const dataSource = useDataSource(results, {
    modules: ['dataProperties'],
  });

  const handleSelect = selectedItem => () => {
    if (onSelect && typeof onSelect === 'function') {
      onSelect(selectedItem);
    }
  };

  const renderItem = item => (
    <Grid item xs={12} key={item.sku}>
      <ItemCard mediaSize={90} item={item} onClick={handleSelect(item)} dense />
    </Grid>
  );

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle style={{ justifyContent: 'space-between' }}>
        <FormattedMessage {...translations.title} />
        {onClose && (
          <CloseButton aria-label="close" onClick={onClose}>
            <Icon icon={['fal', 'times']} />
          </CloseButton>
        )}
      </DialogTitle>
      <DialogContent style={{ padding: '4px 8px 16px 8px' }}>
        <DataList
          component={DataListGridContainer}
          dataSource={dataSource}
          emptyMessage={intl.formatMessage(translations.emptyMessage)}
          renderItem={renderItem}
        />
      </DialogContent>
    </Dialog>
  );
};

ItemResultsDialog.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onSelect: PropTypes.func,
  results: PropTypes.array,
};

ItemResultsDialog.defaultProps = {
  isOpen: false,
  onClose: undefined,
  onSelect: undefined,
  results: [],
};

export default ItemResultsDialog;
